import type { FC } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import styles from "./LoyaltyPointsBlock.module.scss";

const { sanitize } = dompurify;

type LoyaltyPointsBlockProps = {
  title: string;
  text: string;
  isActive?: boolean;
  onClick: () => void;
  disabled?: boolean;
  dataTestid?: string;
};

export const LoyaltyPointsBlock: FC<LoyaltyPointsBlockProps> = ({
  title,
  text,
  isActive = false,
  onClick,
  disabled = false,
  dataTestid,
}) => {
  const className = classNames(styles.blockWrapper, {
    [styles.active]: isActive,
    [styles.disabled]: disabled,
  });

  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div className={className} onClick={handleClick} data-testid={`${dataTestid}Button`}>
      <div className={styles.title} data-testid={dataTestid}>
        {title}
      </div>
      <div dangerouslySetInnerHTML={{ __html: sanitize(text) }} className={styles.text} />
    </div>
  );
};
